export const auditTrailStyles = {
    opposite: {
        padding: '0px !important',
        color: '#78798E',
        fontSize: '0.75rem',
        minWidth: 180,
        flex: 0.2,
        textAlign: 'left',
        alignContent: 'center',
    },
    title: {
        fontSize: '0.875rem',
        lineHeight: '1.75rem',
        color: '#2B2C35',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        display: 'block',
    },
    subtitle: {
        marginTop: 8,
        color: '#78798E',
        fontSize: '0.75rem',
    },
    connector: {
        width: 1,
        background: 'linear-gradient(180deg, #D5D6DD 60%, transparent 40%)',
        backgroundSize: '2px 8px',
    },
    content: {
        textAlign: 'left',
        minWidth: 0,
    },
    dot: {
        height: '1.5rem',
        width: '1.5rem',
        boxShadow: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
    },
};
